import { RouterType } from '@online-webinar/router';
import { ExamResults } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/exam-result'].update({
        staticData: { title: { page: 'Insights.Exam.PageHeading', forWebinar: true } },
        component: authGuard(ExamResults, { canBroadcast: true })
    });
};
